export default __webpack_public_path__ + "static/Giant_Metal_Hatchframe-679f73221e7cf28c6cdbfd639c860195.png";